import ApiUrls from "Definations/ApiUrls";
import httpRequest from "Utilities/SetAuthToken";

export const adminLogin = async (data: any) => {
    return httpRequest.post(`${ApiUrls.adminLogin}`, data);
}

export const adminLogout = async (data: any) => {
    return httpRequest.post(`${ApiUrls.adminLogout}`, data);
}